import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Agitation } from './components/Agitation';
import { Solution } from './components/Solution';
import { OfferAndGuarantee } from './components/OfferAndGuarantee';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-dark text-white font-sans selection:bg-whatsapp selection:text-black" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Agitation data-id="element-3" />
      <Solution data-id="element-4" />
      <OfferAndGuarantee data-id="element-5" />
      <Footer data-id="element-6" />
    </main>;
}